import UNINITIALISED from "utils/uninitialised";
import {MaybeUninitialised} from "modules/redux_types";
import {TestSetFetchAction} from "../actions/testset_fetch";
import {TestSetAddAction} from "../actions/testset_add";
import actionTypes from "../constants/action_types";
import {TestSet} from "common/flowmaster/types/test";

export default function workflowsReducer(
  state: MaybeUninitialised<TestSet[]> = UNINITIALISED,
  action: TestSetFetchAction | TestSetAddAction,
): typeof state {
  if (action.type === actionTypes.TESTSETS_FETCH.SUCCESS) {
    return (action as TestSetFetchAction).payload;
  }
  if (state !== UNINITIALISED) {
    if (action.type === actionTypes.TESTSET_ADD.SUCCESS) {
      return [...state, (action as TestSetAddAction).payload];
    }
  }
  return state;
}
